export const GetActionIcon = ({ type, size = 24, color }) => {
  const icons = {
    moveTo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_85053)">
          <path
            d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H10.5L14.25 6V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75Z"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.75 11.25H11.25"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.375 13.125L11.25 11.25L9.375 9.375"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1617_85053">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    copy: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_85059)">
          <path
            d="M5.25 7.25025C5.25 6.71975 5.46074 6.21098 5.83586 5.83586C6.21098 5.46074 6.71975 5.25 7.25025 5.25H13.7498C14.0124 5.25 14.2725 5.30174 14.5152 5.40226C14.7579 5.50278 14.9784 5.65012 15.1641 5.83586C15.3499 6.0216 15.4972 6.24211 15.5977 6.48479C15.6983 6.72747 15.75 6.98757 15.75 7.25025V13.7498C15.75 14.0124 15.6983 14.2725 15.5977 14.5152C15.4972 14.7579 15.3499 14.9784 15.1641 15.1641C14.9784 15.3499 14.7579 15.4972 14.5152 15.5977C14.2725 15.6983 14.0124 15.75 13.7498 15.75H7.25025C6.98757 15.75 6.72747 15.6983 6.48479 15.5977C6.24211 15.4972 6.0216 15.3499 5.83586 15.1641C5.65012 14.9784 5.50278 14.7579 5.40226 14.5152C5.30174 14.2725 5.25 14.0124 5.25 13.7498V7.25025Z"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.009 12.5527C2.77901 12.4216 2.5877 12.2321 2.45443 12.0034C2.32116 11.7746 2.25064 11.5147 2.25 11.25V3.75C2.25 2.925 2.925 2.25 3.75 2.25H11.25C11.8125 2.25 12.1185 2.53875 12.375 3"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1617_85059">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    favorite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25M10.5 2.25H5.25C4.85218 2.25 4.47064 2.40804 4.18934 2.68934C3.90804 2.97064 3.75 3.35218 3.75 3.75V14.25C3.75 14.6478 3.90804 15.0294 4.18934 15.3107C4.47064 15.592 4.85218 15.75 5.25 15.75H12.75C13.1478 15.75 13.5294 15.592 13.8107 15.3107C14.092 15.0294 14.25 14.6478 14.25 14.25V6M10.5 2.25L14.25 6M8.85 12.6128L7.221 13.4663C7.17265 13.4914 7.11827 13.5026 7.06392 13.4987C7.00956 13.4947 6.95738 13.4757 6.91319 13.4438C6.869 13.412 6.83455 13.3684 6.81368 13.3181C6.7928 13.2677 6.78634 13.2126 6.795 13.1588L7.10625 11.3505L5.7885 10.0703C5.74916 10.0322 5.72131 9.98391 5.70813 9.93082C5.69494 9.87773 5.69695 9.822 5.71392 9.76999C5.73089 9.71798 5.76214 9.67179 5.8041 9.6367C5.84607 9.6016 5.89706 9.57901 5.95125 9.5715L7.77225 9.3075L8.58675 7.66275C8.6111 7.61377 8.64865 7.57255 8.69516 7.54374C8.74166 7.51492 8.79529 7.49966 8.85 7.49966C8.90471 7.49966 8.95833 7.51492 9.00484 7.54374C9.05134 7.57255 9.08889 7.61377 9.11325 7.66275L9.92775 9.3075L11.7487 9.5715C11.8028 9.57928 11.8536 9.60201 11.8953 9.63714C11.9371 9.67227 11.9682 9.71839 11.9852 9.77029C12.0021 9.82218 12.0042 9.87778 11.9912 9.93079C11.9781 9.9838 11.9505 10.0321 11.9115 10.0703L10.5937 11.3505L10.9042 13.158C10.9136 13.2119 10.9076 13.2673 10.887 13.318C10.8664 13.3687 10.832 13.4126 10.7877 13.4447C10.7434 13.4768 10.691 13.4958 10.6364 13.4996C10.5819 13.5034 10.5273 13.4919 10.479 13.4663L8.85 12.6128Z"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    download: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_85066)">
          <path
            d="M3 12.75V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V12.75"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.25 8.25L9 12L12.75 8.25"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 3V12"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1617_85066">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    share: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_85071)">
          <path
            d="M2.25 9C2.25 9.59674 2.48705 10.169 2.90901 10.591C3.33097 11.0129 3.90326 11.25 4.5 11.25C5.09674 11.25 5.66903 11.0129 6.09099 10.591C6.51295 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.51295 7.83097 6.09099 7.40901C5.66903 6.98705 5.09674 6.75 4.5 6.75C3.90326 6.75 3.33097 6.98705 2.90901 7.40901C2.48705 7.83097 2.25 8.40326 2.25 9Z"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 4.5C11.25 5.09674 11.4871 5.66903 11.909 6.09099C12.331 6.51295 12.9033 6.75 13.5 6.75C14.0967 6.75 14.669 6.51295 15.091 6.09099C15.5129 5.66903 15.75 5.09674 15.75 4.5C15.75 3.90326 15.5129 3.33097 15.091 2.90901C14.669 2.48705 14.0967 2.25 13.5 2.25C12.9033 2.25 12.331 2.48705 11.909 2.90901C11.4871 3.33097 11.25 3.90326 11.25 4.5Z"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 13.5C11.25 14.0967 11.4871 14.669 11.909 15.091C12.331 15.5129 12.9033 15.75 13.5 15.75C14.0967 15.75 14.669 15.5129 15.091 15.091C15.5129 14.669 15.75 14.0967 15.75 13.5C15.75 12.9033 15.5129 12.331 15.091 11.909C14.669 11.4871 14.0967 11.25 13.5 11.25C12.9033 11.25 12.331 11.4871 11.909 11.909C11.4871 12.331 11.25 12.9033 11.25 13.5Z"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.52539 8.02461L11.4754 5.47461"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.52539 9.97461L11.4754 12.5246"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1617_85071">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    delete: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_85078)">
          <path
            d="M3 5.25H15"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 8.25V12.75"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 8.25V12.75"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 5.25L4.5 14.25C4.5 14.6478 4.65804 15.0294 4.93934 15.3107C5.22064 15.592 5.60218 15.75 6 15.75H12C12.3978 15.75 12.7794 15.592 13.0607 15.3107C13.342 15.0294 13.5 14.6478 13.5 14.25L14.25 5.25"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.75 5.25V3C6.75 2.80109 6.82902 2.61032 6.96967 2.46967C7.11032 2.32902 7.30109 2.25 7.5 2.25H10.5C10.6989 2.25 10.8897 2.32902 11.0303 2.46967C11.171 2.61032 11.25 2.80109 11.25 3V5.25"
            stroke={color}
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1617_85078">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    cross: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_1657_103795)">
          <path
            d="M13.5 4.5L4.5 13.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 4.5L13.5 13.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1657_103795">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    restore: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M1.28711 8.61762C1.45518 10.2676 2.22481 11.7979 3.44916 12.9166C4.67351 14.0354 6.26688 14.6642 7.92527 14.6832C9.58365 14.7021 11.191 14.1098 12.4406 13.0193C13.6901 11.9289 14.4945 10.4165 14.7002 8.77083C14.9059 7.12514 14.4986 5.46132 13.5559 4.0968C12.6132 2.73229 11.2011 1.76259 9.58907 1.37273C7.97705 0.982876 6.27792 1.20014 4.81586 1.98307C3.3538 2.76601 2.23115 4.0598 1.66211 5.61762M1.28711 1.86762V5.61762H5.03711"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    block: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM3 9C3 5.685 5.685 3 9 3C10.38 3 11.64 3.465 12.645 4.2525L4.2525 12.645C3.465 11.64 3 10.38 3 9ZM9 15C7.62 15 6.36 14.535 5.355 13.7475L13.7475 5.355C14.535 6.36 15 7.62 15 9C15 12.315 12.315 15 9 15Z"
          fill={color}
        />
      </svg>
    ),
    unblock: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path d="M12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16Z" fill={color} />
        <path d="M16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8ZM9.4 16C9.4 12.3548 12.3548 9.4 16 9.4C19.6452 9.4 22.6 12.3548 22.6 16C22.6 19.6452 19.6452 22.6 16 22.6C12.3548 22.6 9.4 19.6452 9.4 16Z" fill={color} />
      </svg>
    )
  };

  return icons[type];
};

export default GetActionIcon;
